export const LAMBDATEST_CONCURRENCY_DATA_LOADING =
  "LAMBDATEST_CONCURRENCY_DATA_LOADING";
export const LAMBDATEST_CONCURRENCY_DATA_SUCCESS =
  "LAMBDATEST_CONCURRENCY_DATA_SUCCESS";
export const LAMBDATEST_CONCURRENCY_DATA_FAILED =
  "LAMBDATEST_CONCURRENCY_DATA_FAILED";
export const LAMBDATEST_CONCURRENCY_DATA_CLEAR =
  "LAMBDATEST_CONCURRENCY_DATA_CLEAR";
export const LAMBDATEST_CONCURRENCY_DATA_SILENT_LOADING =
  "LAMBDATEST_CONCURRENCY_DATA_SILENT_LOADING";
